/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Voucher_ApplyInputs */

const en_billing_voucher_apply = /** @type {(inputs: Billing_Voucher_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const id_billing_voucher_apply = /** @type {(inputs: Billing_Voucher_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Billing_Voucher_ApplyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_voucher_apply = /** @type {((inputs?: Billing_Voucher_ApplyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Voucher_ApplyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_voucher_apply(inputs)
	return en_billing_voucher_apply(inputs)
});